const HallFiledCard = ({
  title,
  children,
  labelClass = false,
  containerClass = false,
  isRequired = false,
  isSingleLine = false,
}) => {
  return (
    <div
      className={`field-card-container ${containerClass} ${isSingleLine ? 'd-flex align-items-center' : ''}`}
      data-testid="filed-card"
    >
      <p className={`field-card-title lh-10 mt-0 mb-2 mx-0 ${labelClass} ${isRequired ? 'fw-800 f-14' : ''} `}>
        {title}
        {isRequired ? <span className="ml-2 pt-5 text-iconDanger fw-800 f-18">*</span> : <></>}
      </p>
      <div className="content fw-600 f-14">{children}</div>
    </div>
  );
};

export default HallFiledCard;
